import { render, staticRenderFns } from "./SingleBudgetVariantField.vue?vue&type=template&id=e2389360&"
import script from "./SingleBudgetVariantField.vue?vue&type=script&lang=ts&"
export * from "./SingleBudgetVariantField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports